module.exports = __webpack_public_path__ + "static/img/17.3bdab4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/17.jpg
// module id = yilG
// module chunks = 16